/**
 * Created by koqiui on 2017-04-09.
 */
import { MsgBox, Vue } from '../../app.vues';
//
import SwbBizUnionTypeForSelect from './BizUnionTypeForSelect';
import SwbApplyDesc from './ApplyDesc';
import BizUnionMerchantForSelect from './BizUnionMerchantForSelect';
import SwbAudit from './Audit';
Vue.regist(SwbBizUnionTypeForSelect);
Vue.regist(SwbApplyDesc);
Vue.regist(BizUnionMerchantForSelect);
Vue.regist(SwbAudit);

export function openBizUnionTypeSelectDlg(bizUnionTypeCodeList, callback) {
    Vue.$showDialog({
        title: "商业联盟类型",
        showCloseBtn: true,
        width: 1000,
        height: 600,
        template: '<div >' +
        '<swb-biz-union-type-select :bizUnionTypeCodeList="bizUnionTypeCodeList" ref="swb_biz_union_type_select"></swb-biz-union-type-select>' +
        '</div>',
        data: {
            bizUnionTypeCodeList: bizUnionTypeCodeList,
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_biz_union_type_select.getDlgResult() || {};
            if(result.type === 'info') {
                let bizUnionTypeList = result.data;
                callback(bizUnionTypeList);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
    });
}

// 简单的申请描述弹出框
export function openApplyDescDlg(callback, title) {
    Vue.$showDialog({
        title: title || '申请原因',
        width: 500,
        height: 300,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-apply-desc ref="swb_apply_desc"/>' +
        '</div>',
        data: {},
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_apply_desc.getDlgResult() || {};
            if(result.type === 'info') {
                let data = result.data;
                callback(data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {}
    });
}

export function showMerchantSelectDialog(dlgArgs, callback, thisArg) {
    let theDlg = Vue.$showDialog({
        title: "商户列表",
        width: 945,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<div><swb-biz-union-merchant-select :vendorAllowed="vendorAllowed" :servicerAllowed="servicerAllowed" :retailerAllowed="retailerAllowed" :multiSelect="multiSelect" :initCheckedItem="initCheckedItem" :initCheckedItems="initCheckedItems" ref="swb_orientation_bid_list"></swb-biz-union-merchant-select></div>',
        data: {
            loading: false,
            vendorAllowed: dlgArgs['vendorAllowed'],
            servicerAllowed: dlgArgs['servicerAllowed'],
            retailerAllowed: dlgArgs['retailerAllowed'],
            multiSelect: dlgArgs['multiSelect'],
            initCheckedItem: dlgArgs['initCheckedItem'],
            initCheckedItems: dlgArgs['initCheckedItems'],
        },
        okClicked: function () {
            let dlgResult = this.$refs.swb_orientation_bid_list.getResult() || {};
            let resultData = dlgResult.data || null;
            //
            if(typeof callback == "function") {
                return callback.apply(thisArg, [resultData]);
            }
        }
    });
};

export function openAuditDlg(voucher, callback, title) {
    title = title || '审核操作';
    let theDlg = Vue.$showDialog({
        title: title,
        showCloseBtn: true,
        width: 500,
        template: '<div v-loading="loading" element-loading-text="加载中...">' +
        '<swb-audit :voucher="voucher" :showApplyInfo="showApplyInfo" :showAuditDesc="showAuditDesc" ref="swb_audit"/>' +
        '</div>',
        data: {
            loading: false,
            voucher: voucher,
            showApplyInfo: voucher.showApplyInfo,
            showAuditDesc: voucher.showAuditDesc
        },
        okClicked: function () {
            let result = this.$refs.swb_audit.getDlgResult() || {};
            if(result.type === 'info') {
                let data = result.data;
                callback(data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/bizUnion/selectDlg.js
// module id = 62
// module chunks = 0